<template>

    <div class="filter-group level_1">
        <div class="checkbox-group">
            <input type="checkbox" :id="props.id"
                   :name="name"
                   :value="value"
                   :checked="info.active"
                   :filterType="props.filterType"
                   v-model="martinChecked"
            >
            <label :for="props.id"
                   v-html="info.title"></label>
        </div>
    </div>

</template>

<script setup>
import { computed, ref, watch } from 'vue';
import { uniqueId }             from "lodash-es";
import { useStore }                         from "vuex";


let store    = useStore();

const props = defineProps( [
    "filterCategory",
    "name",
    "label",
    "value",
    "checked",
    "info",
    "filterType",
    "id",
] );

const emit = defineEmits([
    'changedFilter'
])

let value            = computed( () => props.value );
let name             = computed( () => props.name );
let label            = computed( () => props.label );

let checked = ref( props.checked );

let martinChecked = computed(
    {
        get ()
        {
            return props.info.active
        },
        set ( val )
        {
            changeChecked( val )
        },
    },
);

let info = ref( props.info );

function resetFilters ()
{

    //console.log( '[FILTER.VUE] Resetting filters' );

}

function changeChecked ( val )
{

    store.commit( 'checkFilter', {
        type   : props.filterType,
        id     : info.value.id,
        active : val,
    } );


    emit("changedFilters");


}

</script>

<style scoped>

</style>
